export interface AppState {
  snackbar: Snackbar
  snackbarQueue: Snackbar[]
  isWebview: boolean
  isVisibleApplicationBanner: boolean
  activeCategorySlug: string
  isCategoryBlockScrolling: boolean
}

export interface Snackbar {
  type: SnackbarType
  message: string
  show: boolean
  location: SnackbarLocation
  timeout?: number
}

export enum SnackbarType {
  SUCCESS = 'success',
  MESSAGE = 'message',
}

export enum SnackbarLocation {
  TOP = 'top',
  BOTTOM = 'bottom',
}

/**
 * Перечисление соц. сетей для яндекс метрики
 */
export enum SOCIAL_NETWORKS {
  vkontakte = 'VK',
  odnoklassniki = 'odnoklassniki',
  facebook = 'facebook',
  telegram = 'telegram',
  instagram = 'instagram',
}
